import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { AuthService } from './service/auth.service';
import { HttpService } from './service/http.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private auth: AuthService,
    private router: Router,
    private titleService: Title,
    public httpService: HttpService
  ) {
    this.router.events.subscribe(() => {
      if (this.auth.getToken()) {
        if (this.auth.isLogin()) {
          this.isLogin = true;
        } else {
          localStorage.removeItem('token');
          this.isLogin = false;
        }
      } else {
        this.isLogin = false;
      }
    });
  }

  title = 'app';

  isLogin = false;

  isBrowser = false;

  public objAgent = navigator.userAgent;

  public objbrowserName = navigator.appName;

  public objOffsetName: number;

  private objOffsetVersion: number;

  ngOnInit() {
    // In Chrome
    if (this.objAgent.indexOf('Chrome') !== -1) {
      this.objbrowserName = 'Chrome';
      this.objOffsetVersion = this.objAgent.indexOf('Chrome');
    } else if (this.objAgent.indexOf('MSIE') !== -1) {
      // In Microsoft internet explorer
      this.objbrowserName = 'Microsoft Internet Explorer';
      this.objOffsetVersion = this.objAgent.indexOf('MSIE');
    } else if (this.objAgent.indexOf('Firefox') !== -1) {
      // In Firefox
      this.objbrowserName = 'Firefox';
      this.objOffsetVersion = this.objAgent.indexOf('Firefox');
    } else if (this.objAgent.indexOf('Safari') !== -1) {
      // In Safari
      this.objbrowserName = 'Safari';
      this.objOffsetVersion = this.objAgent.indexOf('Safari');
    } else if (this.objAgent.lastIndexOf(' ') + 1 < this.objAgent.lastIndexOf('/')) {
      // For other browsers, "name/version" is at the end of userAgent
      this.objOffsetName = this.objAgent.lastIndexOf(' ') + 1;
      this.objOffsetVersion = this.objAgent.lastIndexOf('/');
      this.objbrowserName = this.objAgent.substring(this.objOffsetName, this.objOffsetVersion);
      if (this.objbrowserName.toLowerCase() === this.objbrowserName.toUpperCase()) {
        this.objbrowserName = navigator.appName;
      }
    }

    this.isBrowser = this.objbrowserName === 'Safari';

    if (this.auth.getToken()) {
      if (this.auth.isLogin()) {
        this.isLogin = true;
      } else {
        localStorage.removeItem('token');
        this.isLogin = false;
      }
    } else {
      this.isLogin = false;
    }
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  onActivate(event: any) {
    //
    // The OpEx page uses the navToggle to make the content portion of the screen much wider. We have to turn
    // on navToggle when we enter the page, and when we enter any other page, turn it off again.
    //
    if (event.constructor.name === 'OperatingexpensesComponent') {
      $('body').addClass('navToggle');
      $('#pageContent').addClass('navToggle');
    } else {
      $('body').removeClass('navToggle');
      $('#pageContent').removeClass('navToggle');
    }

    //
    // When changing pages, do an animated scroll to the top of the new page.
    //
    if (isPlatformBrowser(this.platformId)) {
      const scrollToTop = window.setInterval(() => {
        const pos = window.pageYOffset;
        if (pos > 0) {
          window.scrollTo(0, pos - 100); // how far to scroll on each step
        } else {
          window.clearInterval(scrollToTop);
        }
      }, 16);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts